import React, { useEffect, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import StickyBox from "react-sticky-box";
import Modal from "react-modal";
import { connect } from "react-redux";
import InputMask from "react-input-mask";
import { toast } from "react-toastify";

//Import Store
import store from "../../../../../store";

//import Custom Component
// import WidgetBanner from '../../../../features/banner/widget-banner';
// import FeaturedProductsTwo from '../product-groups/featured-products-two';
import ValidateUserDataPricing from "../../../../features/validation/user_data_pricing";
import ValidatePostCode from "../../../../features/validation/post-code";
// import ValidateBranch from '../../../../features/validation/branch';
import ValidateRegulations from "../../../../features/validation/regulations";
import ValidateEmail from "../../../../features/validation/email";
import ValidatePhone from "../../../../features/validation/phone";
import LocalStockBar from "../local-stock-bar";

//Import Action
import {
  getFavoriteProducts,
  addFavoriteProduct,
  deleteFavoriteProduct,
} from "../../../../../action/users";
import { getOnDeliveryConfig, getOnProductDeliveryCost } from "../../../../../action/products";
import { checkIfEmail } from "../../../../../action/checkIfEmail";
import { checkIfPhone } from "../../../../../action/checkIfPhone";
import { addToPricing, quickAddToCart } from "../../../../../action/cart";
import { newOrder } from "../../../../../action/newOrder";

//import Utils
import {
  stickyContentHandle,
  setStickyValues,
  getToken,
  getUser,
  getPostCode,
  getBranch,
  setPostCode,
  setBranch,
  findProductSKU,
  setUserSession,
} from "../../../../../utils";
import { useDebounce } from "../../../../../utils/useDebounce";

import { AddToCartTracking } from "../../../../../utils/facebookPixelEvent";
import postcode from "../../../../../mock-data/postcode.json";

//Import Context
import { AuthenticationContext } from "../../../others/common/context";

// Import API call
import { getAllDeliveryForms } from "../../../../../api";
import { getAdditionalPriceFromNumericAttributes, getAttributeValues } from "../../../../../utils/numericAttributes";



function ProductSidebarOne(props) {
  let location = useLocation();
  const {
    dataProduct,
    branches,
    isLoading,
    productDeliveryCost,
    wishlist,
    productPriceHistory,
    productLastPrice,
    colorCode,
    deliveryConfig,
  } = props;
  const token = getToken();
  const user = getUser();
  const branch = getBranch();
  const postCode = getPostCode();
  const qtyFromLogin = location.state ? location.state.productPricingQty : "";
  let wishlisted = findProductSKU(
    wishlist,
    dataProduct.product_sku
      ? dataProduct.product_sku
      : dataProduct.product_variant_sku
  )
    ? true
    : false;

  const [errorPC, setErrorPC] = useState([]);
  // const [errorBranch, setErrorBranch] = useState([]);
  const [errorUserData, setErrorUserData] = useState([]);
  const [errorRegulations, setErrorRegulations] = useState([]);
  const [openDeliveryCost, setOpenDeliveryCost] = useState(false);
  // const [openBranch, setOpenBranch] = useState(false);
  const [openPricing, setOpenPricing] = useState(false);
  // const [openHistoryPrice, setOpenHistoryPrice] = useState(false);
  const [isSendCart, setIsSendCart] = useState(false);
  const [count, setCount] = useState(1);
  const [productPricingQty, setProductPricingQty] = useState(
    qtyFromLogin ? qtyFromLogin : ""
  );
  const [productDataToForm, setProductDataToForm] = useState(false);
  // const [productChangeQty, setProductChangeQty] = useState(false);
  const [checkEmail, setCheckEmail] = useState(false);
  const [checkPhone, setCheckPhone] = useState(false);
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [sendOrder, setSendOrder] = useState(false);
  const [order, setOrder] = useState(null);
  const { loggedIn } = useContext(AuthenticationContext);
  const { setLoggedIn } = useContext(AuthenticationContext);
  // const [noPLnumber, setNoPLnumber] = useState(false);
  const [fullPackage, setFullPackage] = useState(1);
  const [timer, setTimer] = useState(null);
  const [countD, setCountD] = useState(false);
  const [form, setForm] = useState({
    branch_id: branch ? branch : 22,
    id: user ? user.id : "",
    name: user ? user.name : "",
    last_name: user
      ? user.last_name && user.last_name !== ""
        ? user.last_name
        : "X"
      : "X",
    phone: user ? user.phone : "",
    email: user ? user.email : "",
    comment: "",
    delivery_method: "",
    address_city: "",
    address_post: user
      ? postCode
        ? postCode
        : user.address_post
      : postCode
        ? postCode
        : "",
    address_street: "",
    payment_method: "",
    cartItemsBuy: [],
    cartItemsPricing: [],
    regulations: user ? true : false,
  });

  const deliveryTime =
    dataProduct.product_variant_delivery_time ||
    dataProduct.product?.product_delivery_time;

  useEffect(() => {
    if (colorCode) {
      setForm({
        ...form,
        comment: `kolor: ${colorCode}`,
      });
    }
  }, [colorCode]);

  // useEffect(() => {
  //   if (user && user.phone) {
  //     setForm({
  //       ...form,
  //       email: ''
  //     });
  //   }
  // }, []);

  // const handleChangeNoPLnumber = (e) => {
  //   setNoPLnumber(e.target.checked);
  //   setForm({
  //     ...form,
  //     phone: '',
  //     email: user ? user.email ? user.email : "" : "",
  //   });
  // }

  useEffect(() => {
    setStickyValues(120);
    window.addEventListener("scroll", stickyContentHandle);

    return () => {
      window.removeEventListener("scroll", stickyContentHandle);
    };
  });

  useEffect(() => {
    if (branch && postCode && !productDeliveryCost) {
      store.dispatch(
        getOnProductDeliveryCost(form.branch_id, form.address_post)
      );
    }
  }, []);

  useEffect(() => {
    store.dispatch(getOnDeliveryConfig());
  }, []);

  useEffect(() => {
    if (loggedIn) {
      setOpenPricing(true);
      setProductDataToForm(true);
    }
  }, [loggedIn]);

  useEffect(() => {
    if ((productDataToForm || productPricingQty) && isLoading === false) {
      setForm({
        ...form,
        cartItemsPricing: [
          {
            product_id: dataProduct.product_id,
            product_variant_id: dataProduct.product_variant_id
              ? dataProduct.product_variant_id
              : "",
            promo_on: dataProduct.prices ? dataProduct.prices.promo_on : "",
            promo_price_on: dataProduct.prices
              ? dataProduct.prices.promo_price_on
              : "",
            product_qty:
              (dataProduct.package &&
                dataProduct.package.package_value_type === "metric") ||
                (dataProduct.product &&
                  dataProduct.product.package.package_value_type === "metric")
                ? parseFloat(productPricingQty)
                : parseInt(productPricingQty),
            numeric_values: dataProduct.numeric_values ?? [],
          },
        ],
      });
      setProductDataToForm(false);
      // setProductChangeQty(false);
    }
  }, [productDataToForm, productPricingQty, isLoading]);

  useEffect(() => {
    if (
      (user ? (user.email !== form.email ? true : false) : true) &&
      openPricing &&
      ValidateEmail(form.email)
    ) {
      store.dispatch(checkIfEmail({ email: form.email }, setCheckEmail));
    }
    setCheckEmail(false);
  }, [form.email]);

  useEffect(() => {
    const phone = form.phone && form.phone.replace("+48", "");
    const phone1 = phone && phone.replace(/\s/g, "");
    if (
      (user ? (user.phone !== phone1 ? true : false) : true) &&
      ValidatePhone(form.phone)
    ) {
      store.dispatch(checkIfPhone({ phone: form.phone }, setCheckPhone));
    }
    setCheckPhone(false);
  }, [form.phone]);

  const openModalDeliveryCost = (e) => {
    e.preventDefault();
    setOpenDeliveryCost(true);
  };
  // const openModalBranch = (e) => {
  //   e.preventDefault();
  //   setOpenBranch(true);
  // }
  const openModalPricing = (e) => {
    e.preventDefault();
    setProductPricingQty(count);
    setOpenPricing(true);
    setProductDataToForm(true);
  };
  // const openModalHistoryPrice = (e) => {
  //   e.preventDefault();
  //   setOpenHistoryPrice(true);
  // }
  const closeModal = (e) => {
    e.preventDefault();
    document.querySelector(".modal-body").style.opacity = 0;
    setOpenDeliveryCost(false);
    // setOpenBranch(false);
    setOpenPricing(false);
    // setOpenHistoryPrice(false);
    setIsSendCart(false);
    setLoggedIn(false);

    setTimeout(() => {
      if (document.querySelector(".sticky-header.fixed")) {
        document.querySelector(".sticky-header.fixed").style.paddingRight =
          0 + "px";
      }

      document.querySelector("html").style.marginRight = 0 + "px";
      document.querySelector("html").style.marginRight = "";
      document.querySelector("html").style.overflow = "";
    }, 200);
  };

  const handleSubmitDeliveryCost = (e) => {
    e.preventDefault();
    const errorMsgPC = ValidatePostCode(form);
    // const errorMsgBranch = ValidateBranch(form);

    // if (Object.keys(errorMsgPC).length !== 0 || Object.keys(errorMsgBranch).length !== 0) {
    if (Object.keys(errorMsgPC).length !== 0) {
      setErrorPC(errorMsgPC);
      // setErrorBranch(errorMsgBranch);
      return;
    }
    setErrorPC([]);
    // setErrorBranch([]);
    setPostCode(form.address_post);
    setBranch(form.branch_id);
    setOpenDeliveryCost(false);

    store.dispatch(getOnProductDeliveryCost(form.branch_id, form.address_post));
  };
  // const handleSubmitBranch = (e, branch_id, count) => {
  //   e.preventDefault();
  //   setForm({
  //     ...form,
  //     branch_id: branch_id
  //   });
  //   setBranch(branch_id);
  //   setOpenBranch(false);

  //   let val = count;
  //   props.quickAddToCart(props.dataProduct, val);
  // }
  const handleSubmitPricing = (e) => {
    e.preventDefault();
    const errorMsgPC = ValidatePostCode(form);
    const errorMsgUserData = ValidateUserDataPricing(form);
    // const errorMsgUserData = ValidateUserDataPricing(form, noPLnumber);
    const errorRegulations = ValidateRegulations(form);

    if (
      Object.keys(errorMsgPC).length !== 0 ||
      Object.keys(errorMsgUserData).length !== 0 ||
      Object.keys(errorRegulations).length !== 0 ||
      checkEmail === true ||
      checkPhone === true
    ) {
      setErrorPC(errorMsgPC);
      setErrorUserData(errorMsgUserData);
      setErrorRegulations(errorRegulations);
      return;
    }
    setErrorPC([]);
    setErrorUserData([]);
    setErrorRegulations([]);
    setPostCode(form.address_post);
    setBranch(form.branch_id);
    setDisabledBtn(true);

    store.dispatch(
      newOrder(
        form,
        token,
        setIsSendCart,
        setDisabledBtn,
        setSendOrder,
        setOrder
      )
    );
    setSendOrder(true);
    if (user) {
      setUserSession(token, { ...user, phone: form.phone });
    }
  };

  const setQty = (e) => {
    e.preventDefault();
    let val = e.target.value;
    setCount(val);
    setProductPricingQty(val);

    clearTimeout(timer);

    const newTimer = setTimeout(() => {
      setFullPackage(
        Math.ceil(
          val /
          (dataProduct.product_variant_package_type_full_qty
            ? dataProduct.product_variant_package_type_full_qty
            : dataProduct.product_package_type_full_qty)
        )
      );
      setCountD(true);
    }, 1000);

    setTimer(newTimer);

    // let inputs = document.querySelectorAll('.horizontal-quantity');
    // for (let i = 0; i < inputs.length; i++) {
    //   inputs[i].value = e.target.value;
    // }
  };
  const countUp = () => {
    let quantity =
      (dataProduct.package &&
        dataProduct.package.package_value_type === "metric") ||
        (dataProduct.product &&
          dataProduct.product.package.package_value_type === "metric")
        ? parseFloat(document.querySelector(".horizontal-quantity").value)
        : parseInt(document.querySelector(".horizontal-quantity").value);
    // if ( quantity < ( props.stock ? props.stock : 5 ) ) {
    if (quantity) {
      if (
        (dataProduct.package &&
          dataProduct.package.package_value_type === "metric") ||
        (dataProduct.product &&
          dataProduct.product.package.package_value_type === "metric")
      ) {
        setCount((quantity + 0.01).toFixed(2));
        setProductPricingQty((quantity + 0.01).toFixed(2));
      } else {
        setCount(quantity + 1);
        setProductPricingQty(quantity + 1);
      }

      let inputs = document.querySelectorAll(".horizontal-quantity");
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].value = quantity + 1;
      }
    } else {
      if (
        (dataProduct.package &&
          dataProduct.package.package_value_type === "metric") ||
        (dataProduct.product &&
          dataProduct.product.package.package_value_type === "metric")
      ) {
        setCount(0.01);
        setProductPricingQty(0.01);
      } else {
        setCount(1);
        setProductPricingQty(1);
      }

      let inputs = document.querySelectorAll(".horizontal-quantity");
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].value = quantity + 1;
      }
    }
  };
  const countDown = () => {
    let quantity =
      (dataProduct.package &&
        dataProduct.package.package_value_type === "metric") ||
        (dataProduct.product &&
          dataProduct.product.package.package_value_type === "metric")
        ? parseFloat(document.querySelector(".horizontal-quantity").value)
        : parseInt(document.querySelector(".horizontal-quantity").value);
    if (quantity > 1) {
      if (
        (dataProduct.package &&
          dataProduct.package.package_value_type === "metric") ||
        (dataProduct.product &&
          dataProduct.product.package.package_value_type === "metric")
      ) {
        setCount((quantity - 0.01).toFixed(2));
        setProductPricingQty((quantity - 0.01).toFixed(2));
      } else {
        setCount(quantity - 1);
        setProductPricingQty(quantity - 1);
      }

      let inputs = document.querySelectorAll(".horizontal-quantity");
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].value = quantity - 1;
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
  };
  const handleChangeCheckbox = (e) => {
    const { name, checked } = e.target;
    setForm({
      ...form,
      [name]: checked,
    });
  };
  const addToCart = (e) => {
    e.preventDefault();
    if (
      !(
        (dataProduct.product && dataProduct.product.full_package) ||
        dataProduct.full_package
      )
    ) {
      props.quickAddToCart(props.dataProduct, Number(count));
      AddToCartTracking(props.dataProduct, count);
    } else {
      props.quickAddToCart(
        props.dataProduct,
        Number(
          fullPackage *
          (dataProduct.product_variant_package_type_full_qty
            ? dataProduct.product_variant_package_type_full_qty
            : dataProduct.product_package_type_full_qty)
        )
      );
      AddToCartTracking(
        props.dataProduct,
        fullPackage *
        (dataProduct.product_variant_package_type_full_qty
          ? dataProduct.product_variant_package_type_full_qty
          : dataProduct.product_package_type_full_qty)
      );
    }
  };

  const handleChangeFullPackage = (e) => {
    setFullPackage(parseInt(e.target.value));
    if (e.target.value) {
      if (
        (dataProduct.product &&
          dataProduct.product.package.package_value_type === "metric") ||
        (dataProduct.package &&
          dataProduct.package.package_value_type === "metric")
      ) {
        setCount(
          (
            e.target.value *
            (dataProduct.product_variant_package_type_full_qty
              ? dataProduct.product_variant_package_type_full_qty
              : dataProduct.product_package_type_full_qty)
          ).toFixed(2)
        );
        setProductPricingQty(
          (
            e.target.value *
            (dataProduct.product_variant_package_type_full_qty
              ? dataProduct.product_variant_package_type_full_qty
              : dataProduct.product_package_type_full_qty)
          ).toFixed(2)
        );
      } else if (
        (dataProduct.product &&
          dataProduct.product.package.package_value_type === "static") ||
        (dataProduct.package &&
          dataProduct.package.package_value_type === "static")
      ) {
        setCount(
          e.target.value *
          (dataProduct.product_variant_package_type_full_qty
            ? dataProduct.product_variant_package_type_full_qty
            : dataProduct.product_package_type_full_qty)
        );
        setProductPricingQty(
          e.target.value *
          (dataProduct.product_variant_package_type_full_qty
            ? dataProduct.product_variant_package_type_full_qty
            : dataProduct.product_package_type_full_qty)
        );
      }
    }
  };
  useEffect(() => {
    if (
      countD &&
      ((dataProduct.product && dataProduct.product.full_package) ||
        dataProduct.full_package)
    ) {
      if (
        (dataProduct.product &&
          dataProduct.product.package.package_value_type === "metric") ||
        (dataProduct.package &&
          dataProduct.package.package_value_type === "metric")
      ) {
        setCount(
          (
            fullPackage *
            (dataProduct.product_variant_package_type_full_qty
              ? dataProduct.product_variant_package_type_full_qty
              : dataProduct.product_package_type_full_qty)
          ).toFixed(2)
        );
        setProductPricingQty(
          (
            fullPackage *
            (dataProduct.product_variant_package_type_full_qty
              ? dataProduct.product_variant_package_type_full_qty
              : dataProduct.product_package_type_full_qty)
          ).toFixed(2)
        );
      } else if (
        (dataProduct.product &&
          dataProduct.product.package.package_value_type === "static") ||
        (dataProduct.package &&
          dataProduct.package.package_value_type === "static")
      ) {
        setCount(
          fullPackage *
          (dataProduct.product_variant_package_type_full_qty
            ? dataProduct.product_variant_package_type_full_qty
            : dataProduct.product_package_type_full_qty)
        );
        setProductPricingQty(
          fullPackage *
          (dataProduct.product_variant_package_type_full_qty
            ? dataProduct.product_variant_package_type_full_qty
            : dataProduct.product_package_type_full_qty)
        );
      }
      setCountD(false);
    }
  }, [fullPackage && countD]);

  useEffect(() => {
    if (
      (dataProduct.product && dataProduct.product.full_package) ||
      dataProduct.full_package
    ) {
      if (
        (dataProduct.product &&
          dataProduct.product.package.package_value_type === "metric") ||
        (dataProduct.package &&
          dataProduct.package.package_value_type === "metric")
      ) {
        setCount(
          (
            fullPackage *
            (dataProduct.product_variant_package_type_full_qty
              ? dataProduct.product_variant_package_type_full_qty
              : dataProduct.product_package_type_full_qty)
          ).toFixed(2)
        );
        setProductPricingQty(
          (
            fullPackage *
            (dataProduct.product_variant_package_type_full_qty
              ? dataProduct.product_variant_package_type_full_qty
              : dataProduct.product_package_type_full_qty)
          ).toFixed(2)
        );
      } else if (
        (dataProduct.product &&
          dataProduct.product.package.package_value_type === "static") ||
        (dataProduct.package &&
          dataProduct.package.package_value_type === "static")
      ) {
        setCount(
          fullPackage *
          (dataProduct.product_variant_package_type_full_qty
            ? dataProduct.product_variant_package_type_full_qty
            : dataProduct.product_package_type_full_qty)
        );
        setProductPricingQty(
          fullPackage *
          (dataProduct.product_variant_package_type_full_qty
            ? dataProduct.product_variant_package_type_full_qty
            : dataProduct.product_package_type_full_qty)
        );
      }
    } else {
      setCount(1);
    }
  }, [dataProduct]);

  useEffect(() => {
    if (user) {
      store.dispatch(getFavoriteProducts(user.id));
    }
  }, []);

  const onWithWishClick = (e) => {
    if (!user) {
      e.preventDefault();
      const CustomToastWithLink = () => (
        <div>
          Musisz być zalogowany.{" "}
          <Link to={`${process.env.PUBLIC_URL}/logowanie`}>Zaloguj się</Link>
        </div>
      );
      toast.error(CustomToastWithLink);
      return;
    }
    if (!wishlisted) {
      e.preventDefault();
      props.addFavoriteProduct({
        user_id: user.id,
        product_id: dataProduct.product_id,
        product_sku: dataProduct.product_sku
          ? dataProduct.product_sku
          : dataProduct.product_variant_sku,
      });
    } else {
      e.preventDefault();
      const findFavorite = wishlist.find(
        (a) =>
          a.product_sku ===
          (dataProduct.product_sku
            ? dataProduct.product_sku
            : dataProduct.product_variant_sku)
      );
      props.deleteFavoriteProduct({ id: findFavorite.id });
    }
  };

  const isCode = postcode.find((code) => code === form.address_post)
    ? true
    : false;

  // new changes

  const [customDeliveryCost, setCustomDeliveryCost] = useState(null);
  const debouncedQuantity = useDebounce(productPricingQty, 1000);

  useEffect(() => {
    if (dataProduct && isLoading === false) {
      // const productQuantity = productPricingQty ? productPricingQty : 1;
      // for calculate price depend on user quantity
      // add debouncedQuantity to dependency array
      // and uncomment below code
      // let quantity =
      //   (dataProduct.package &&
      //     dataProduct.package.package_value_type === "metric") ||
      //   (dataProduct.product &&
      //     dataProduct.product.package.package_value_type === "metric")
      //     ? parseFloat(productQuantity)
      //     : parseInt(productQuantity);

      const fullPackageQty = dataProduct.product_variant_package_type_full_qty
        ? dataProduct.product_variant_package_type_full_qty
        : dataProduct.product_package_type_full_qty;

      const fullPackageAsNumber = parseFloat(fullPackageQty);

      // fallback is one because min value in input is 1
      const quantity = fullPackageAsNumber ? fullPackageAsNumber : 1;

      const data = [
        {
          product_id: dataProduct.product_id,
          product_variant_id: dataProduct.product_variant_id,
          product_qty: quantity,
        },
      ];

      getAllDeliveryForms({ cartItems: data })
        .then((delivery) => {
          delivery.sort((a, b) => {
            return parseFloat(a.price) - parseFloat(b.price);
          });
          setCustomDeliveryCost(delivery);
        })
        .catch((err) => {
          setCustomDeliveryCost(null);
          console.error("err: ", err);
        });
    }
  }, [dataProduct?.product_id, isLoading]);

  const hasLocalDelivery = () => {
    const localDelivery = dataProduct.product ? dataProduct.product.product_local_delivery : dataProduct.product_variant_local_delivery;
    const localDeliveryWithFallback = localDelivery ?? 1;

    return localDeliveryWithFallback === 1;
  };

  const getDeliveryForProduct = () => {

    if (!productDeliveryCost) return {
      local: {
        price: null,
        name: "Ciężarówka Buduj",
      },
      custom: customDeliveryCost,
    };

    let oldCost = {
      price: 0,
      name: "kurs",
    };

    switch (true) {
      case productDeliveryCost.provider_shop_delivery_type_small === 1:
        oldCost.price =
          productDeliveryCost.provider_shop_delivery_small.toFixed(2);
        break;
      case productDeliveryCost.provider_shop_delivery_type_small_hds === 1:
        oldCost.price =
          productDeliveryCost.provider_shop_delivery_small_hds.toFixed(2);
        break;
      case productDeliveryCost.provider_shop_delivery_type_big === 1:
        oldCost.price =
          productDeliveryCost.provider_shop_delivery_big.toFixed(2);
        break;
      case productDeliveryCost.provider_shop_delivery_type_big_hds === 1:
        oldCost.price =
          productDeliveryCost.provider_shop_delivery_big_hds.toFixed(2);
        break;
      default:
        oldCost.price = 0;
        break;
    }

    if (!hasLocalDelivery()) {
      return {
        local: null,
        custom: customDeliveryCost,
      };
    }

    return {
      local: {
        price: oldCost.price,
        name: "Ciężarówka Buduj",
      },
      custom: customDeliveryCost,
    };
  };

  const deliveryForProduct = getDeliveryForProduct();

  const additionalPrice = getAdditionalPriceFromNumericAttributes(dataProduct);

  useEffect(() => {
    if (dataProduct.product_variant_id && count !== 1) {
      const expectedFullPackage = Math.ceil(
        1 /
        (dataProduct.product_variant_package_type_full_qty
          ? dataProduct.product_variant_package_type_full_qty
          : dataProduct.product_package_type_full_qty)
      );

      setCount(1);
      setProductPricingQty(1);
      setFullPackage(expectedFullPackage);
      setCountD(true);
    }
  }, [dataProduct.product_variant_id]);


  const { attribute1Value, attribute2Value, attribute3Value } = getAttributeValues(dataProduct);

  return (
    <aside className="sidebar-product col-lg-3 padding-left-md mobile-sidebar">
      {isLoading === false ? (
        <StickyBox className="sticky-sidebar border rounded p-4" offsetTop={80}>
          <div className="sidebar-wrapper">
            {/* <div className="widget widget-brand">
                <Link to="#">
                  <img src={ `${process.env.PUBLIC_URL}/assets/images/manufacturers/11.png` } alt="Kronospan" />
                </Link>
              </div> */}
            {dataProduct.prices &&
              (dataProduct.product
                ? dataProduct.product.product_active === 1 &&
                dataProduct.product_variant_active === 1
                : dataProduct.product_active === 1) ? (
              <>
                <div className="row label-group">
                  {dataProduct.prices.promo_on === 1 ? (
                    <>
                      <div className="col-lg-auto">
                        <span className="product-label label-sale d-block">
                          PROMOCJA
                        </span>
                      </div>
                      {/* {productPriceHistory.length ?
                              <div className="col-lg-auto ml-auto">
                                <span onClick={openModalHistoryPrice} className="link" style={{fontSize: '1.2rem',cursor:'pointer',fontFamily:'Poppins'}}>Historia ceny</span>
                              </div>
                            : null} */}
                    </>
                  ) : dataProduct.prices.promo_price_on === 1 ? (
                    <div className="col-lg-auto">
                      <span className="product-label label-sale d-block">
                        KUP TERAZ
                      </span>
                    </div>
                  ) : (
                    <div className="col-lg-auto">
                      <span className="product-label label-sale d-block">
                        DO WYCENY
                      </span>
                    </div>
                  )}
                </div>
                <div className="product-single-details text-center">
                  {dataProduct.prices.promo_on === 1 ? (
                    <>
                      <div className="price-box pb-4 pb-xl-0">
                        <span className="product-price">
                          {(parseFloat(dataProduct.prices.promo_price) + additionalPrice).toFixed(2)}{" "}
                          zł/
                          {dataProduct.product
                            ? dataProduct.product.package.package_value
                            : dataProduct.package.package_value}{" "}
                          <div style={{ fontSize: "14px", color: "gray" }}>
                            Brutto (zawiera 23% VAT)
                          </div>
                        </span>
                        <span className="old-price">
                          {(parseFloat(dataProduct.prices.price) + additionalPrice).toFixed(2)} zł
                        </span>
                      </div>
                      <div className="mb-1">
                        <span>Oszczędzasz</span>:{" "}
                        {(
                          dataProduct.prices.price -
                          dataProduct.prices.promo_price
                        ).toFixed(2)}{" "}
                        zł/
                        {dataProduct.product
                          ? dataProduct.product.package.package_value
                          : dataProduct.package.package_value}
                        <div style={{ fontSize: "14px", color: "gray" }}>
                          Brutto (zawiera 23% VAT)
                        </div>
                      </div>
                      {(dataProduct.product_variant_ean &&
                        dataProduct.product_variant_ean !== 0 &&
                        dataProduct.product_variant_ean !== "0" &&
                        dataProduct.product_variant_ean !== "") ||
                        (dataProduct.product_ean &&
                          dataProduct.product_ean !== 0 &&
                          dataProduct.product_ean !== "0" &&
                          dataProduct.product_ean !== "") ? (
                        <div className="mb-1" style={{ fontSize: "1.2rem" }}>
                          Najniższa cena z ostatnich 30 dni:{" "}
                          {dataProduct.product_variant_ean
                            ? dataProduct.product_variant_ean
                            : dataProduct.product_ean}{" "}
                          zł
                          <div style={{ fontSize: "14px", color: "gray" }}>
                            Brutto (zawiera 23% VAT)
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : dataProduct.prices.promo_price_on === 1 ? (
                    <div className="price-box pb-4 pb-xl-0">
                      <span className="product-price">
                        {(parseFloat(dataProduct.prices.promo_price) + additionalPrice).toFixed(2)}{" "}
                        <span style={{ fontSize: "18px" }}>
                          zł/
                          {dataProduct.product
                            ? dataProduct.product.package.package_value
                            : dataProduct.package.package_value}
                          <div style={{ fontSize: "14px", color: "gray" }}>
                            Brutto (zawiera 23% VAT)
                          </div>
                        </span>
                      </span>
                    </div>
                  ) : (
                    <div className="price-box pb-4 pb-xl-0">
                      <span className="product-price">
                        {parseFloat(dataProduct.prices.price_from) + additionalPrice} -{" "}
                        {parseFloat(dataProduct.prices.price_to) + additionalPrice}{" "}
                        <span style={{ fontSize: "18px" }}>
                          zł/
                          {dataProduct.product
                            ? dataProduct.product.package.package_value
                            : dataProduct.package.package_value}
                          <div style={{ fontSize: "14px", color: "gray" }}>
                            Brutto (zawiera 23% VAT)
                          </div>
                        </span>
                      </span>
                    </div>
                  )}
                </div>
                <div className="widget widget-add-to-cart text-center">
                  {dataProduct.prices.promo_on === 1 ||
                    dataProduct.prices.promo_price_on === 1 ? (
                    <form
                      className="product-action product-all-icons"
                      onSubmit={addToCart}
                    >
                      {(dataProduct.product &&
                        dataProduct.product.full_package) ||
                        dataProduct.full_package ? (
                        <div
                          className="product-single-qty"
                          style={{ maxHeight: "unset", display: "flex" }}
                        >
                          <div className="w-50 float-left pr-0 bootstrap-touchspin bootstrap-touchspin-injected">
                            <input
                              className="horizontal-quantity form-control package-type-left mw-100"
                              type="number"
                              min={
                                (dataProduct.package &&
                                  dataProduct.package.package_value_type ===
                                  "metric") ||
                                  (dataProduct.product &&
                                    dataProduct.product.package
                                      .package_value_type === "metric")
                                  ? "0.01"
                                  : "1"
                              }
                              value={count}
                              step={
                                (dataProduct.package &&
                                  dataProduct.package.package_value_type ===
                                  "metric") ||
                                  (dataProduct.product &&
                                    dataProduct.product.package
                                      .package_value_type === "metric")
                                  ? "0.01"
                                  : "1"
                              }
                              onChange={(e) => setQty(e)}
                              onFocus={(e) => e.target.select()}
                            />
                            <span className="package-unit">
                              {dataProduct.product
                                ? dataProduct.product.package.package_value
                                : dataProduct.package.package_value}
                            </span>
                          </div>
                          <div className="w-50 float-left pl-0 bootstrap-touchspin bootstrap-touchspin-injected">
                            <input
                              className="horizontal-quantity form-control package-type-right mw-100"
                              type="number"
                              min="1"
                              value={fullPackage}
                              onChange={handleChangeFullPackage}
                              onFocus={(e) => e.target.select()}
                            />
                            <span className="package-unit">
                              {dataProduct.product
                                ? dataProduct.product.full_package.package_value
                                : dataProduct.full_package.package_value}
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className="product-single-qty">
                          <div className="input-group bootstrap-touchspin bootstrap-touchspin-injected">
                            <span className="input-group-btn input-group-prepend">
                              <button
                                className="btn btn-outline btn-down-icon bootstrap-touchspin-down"
                                onClick={countDown}
                                type="button"
                              ></button>
                            </span>
                            <input
                              className="horizontal-quantity form-control"
                              type="number"
                              min={
                                (dataProduct.package &&
                                  dataProduct.package.package_value_type ===
                                  "metric") ||
                                  (dataProduct.product &&
                                    dataProduct.product.package
                                      .package_value_type === "metric")
                                  ? "0.01"
                                  : "1"
                              }
                              value={count}
                              step={
                                (dataProduct.package &&
                                  dataProduct.package.package_value_type ===
                                  "metric") ||
                                  (dataProduct.product &&
                                    dataProduct.product.package
                                      .package_value_type === "metric")
                                  ? "0.01"
                                  : "1"
                              }
                              onChange={(e) => setQty(e)}
                              onFocus={(e) => e.target.select()}
                            />
                            <span className="input-group-btn input-group-append">
                              <button
                                className="btn btn-outline btn-up-icon bootstrap-touchspin-up"
                                onClick={countUp}
                                type="button"
                              ></button>
                            </span>
                          </div>
                        </div>
                      )}
                      {count === "" && (
                        <div className="mb-1 text-danger">
                          Nieprawidłowa ilość
                        </div>
                      )}
                      <button
                        type="submit"
                        className="paction add-cart"
                        title="Dodaj do koszyka"
                        disabled={count !== "" ? false : true}
                      >
                        <span>Dodaj do koszyka</span>
                      </button>
                      <div className="d-flex mt-1">
                        <div
                          className="w-100"
                          style={{ paddingRight: ".7rem" }}
                        >
                          <button
                            type="submit"
                            className="paction add-negotiations"
                            title="Wyciśnij cenę"
                            onClick={openModalPricing}
                          >
                            <span>Wyciśnij cenę</span>
                          </button>
                          <span className="negotiations-qty">
                            od{" "}
                            {dataProduct.product
                              ? dataProduct.product.product_qty_medium
                              : dataProduct.product_qty_medium}{" "}
                            {dataProduct.product && dataProduct.product.package
                              ? dataProduct.product.package.package_value
                              : dataProduct.package &&
                              dataProduct.package.package_value}
                          </span>
                        </div>
                        <button
                          className={`paction add-wishlist ${wishlisted === true ? "checked" : ""
                            }`}
                          title={`${wishlisted === true
                            ? "Usuń z ulubionych"
                            : "Dodaj do ulubionych"
                            }`}
                          style={{ height: "39px", minWidth: "39px" }}
                          onClick={onWithWishClick}
                        ></button>
                      </div>
                    </form>
                  ) : (
                    <form
                      className="product-action product-all-icons"
                      onSubmit={openModalPricing}
                    >
                      {/* <Qty stock={product.stock} /> */}
                      {(dataProduct.product &&
                        dataProduct.product.full_package) ||
                        dataProduct.full_package ? (
                        <div
                          className="product-single-qty"
                          style={{ maxHeight: "unset", display: "flex" }}
                        >
                          <div className="w-50 float-left pr-0 bootstrap-touchspin bootstrap-touchspin-injected">
                            <input
                              className="horizontal-quantity form-control package-type-left mw-100"
                              type="number"
                              min={
                                (dataProduct.package &&
                                  dataProduct.package.package_value_type ===
                                  "metric") ||
                                  (dataProduct.product &&
                                    dataProduct.product.package
                                      .package_value_type === "metric")
                                  ? "0.01"
                                  : "1"
                              }
                              value={count}
                              step={
                                (dataProduct.package &&
                                  dataProduct.package.package_value_type ===
                                  "metric") ||
                                  (dataProduct.product &&
                                    dataProduct.product.package
                                      .package_value_type === "metric")
                                  ? "0.01"
                                  : "1"
                              }
                              onChange={(e) => setQty(e)}
                              onFocus={(e) => e.target.select()}
                            />
                            <span className="package-unit">
                              {dataProduct.product
                                ? dataProduct.product.package.package_value
                                : dataProduct.package.package_value}
                            </span>
                          </div>
                          <div className="w-50 float-left pl-0 bootstrap-touchspin bootstrap-touchspin-injected">
                            <input
                              className="horizontal-quantity form-control package-type-right mw-100"
                              type="number"
                              min="1"
                              value={fullPackage}
                              onChange={handleChangeFullPackage}
                              onFocus={(e) => e.target.select()}
                            />
                            <span className="package-unit">
                              {dataProduct.product
                                ? dataProduct.product.full_package.package_value
                                : dataProduct.full_package.package_value}
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className="product-single-qty">
                          <div className="input-group bootstrap-touchspin bootstrap-touchspin-injected">
                            <span className="input-group-btn input-group-prepend">
                              <button
                                className="btn btn-outline btn-down-icon bootstrap-touchspin-down"
                                onClick={countDown}
                                type="button"
                              ></button>
                            </span>
                            <input
                              className="horizontal-quantity form-control"
                              type="number"
                              min={
                                (dataProduct.package &&
                                  dataProduct.package.package_value_type ===
                                  "metric") ||
                                  (dataProduct.product &&
                                    dataProduct.product.package
                                      .package_value_type === "metric")
                                  ? "0.01"
                                  : "1"
                              }
                              value={count}
                              onChange={(e) => setQty(e)}
                              step={
                                (dataProduct.package &&
                                  dataProduct.package.package_value_type ===
                                  "metric") ||
                                  (dataProduct.product &&
                                    dataProduct.product.package
                                      .package_value_type === "metric")
                                  ? "0.01"
                                  : "1"
                              }
                              onFocus={(e) => e.target.select()}
                            />
                            <span className="input-group-btn input-group-append">
                              <button
                                className="btn btn-outline btn-up-icon bootstrap-touchspin-up"
                                onClick={countUp}
                                type="button"
                              ></button>
                            </span>
                          </div>
                        </div>
                      )}
                      <div style={{ display: "flex" }}>
                        <button
                          type="submit"
                          className="paction add-negotiations"
                          title="Wyciśnij cenę"
                        >
                          <span>Wyciśnij cenę</span>
                        </button>
                        <button
                          className={`paction add-wishlist ${wishlisted === true ? "checked" : ""
                            }`}
                          title={`${wishlisted === true
                            ? "Usuń z ulubionych"
                            : "Dodaj do ulubionych"
                            }`}
                          style={{ height: "39px", minWidth: "39px" }}
                          onClick={onWithWishClick}
                        ></button>
                      </div>
                    </form>
                  )}
                </div>
              </>
            ) : (
              <div className="text-danger text-center mb-2">
                Przepraszamy, produkt jest chwilowo niedostępny.
              </div>
            )}

            {isLoading === false ? <LocalStockBar active /> : null}

            <div className="widget widget-info">
              {branch ? (
                <>
                  <div className="section">
                    <div className="font-orange font-semibold" style={{ fontSize: "1.6rem" }}>
                      SPRZEDAŻ LOKALNIE {deliveryForProduct?.local ? <span style={{ color: "#2e7d32" }}>✔</span> : "❌"}
                    </div>
                    <small>(w Ø 60 km od 17-200 Hajnówka)</small>
                  </div>
                  <>
                    {deliveryForProduct?.local && (
                      <>
                        <div className="section">
                          <span className="font-orange font-semibold">
                            0zł
                          </span>{" "} - Odbiór osobisty
                          <br />
                          {postCode && branch && deliveryForProduct?.local?.price && (
                            <>
                              <span className="font-orange font-semibold">
                                0zł
                              </span>{" "} - dla zamówień powyżej{" "}
                              <span className="font-orange font-semibold">
                                {postCode === "17-200" ? `${deliveryConfig?.own_free_delivery_cart_value?.value ?? "1 500"}zł ` : `${deliveryConfig?.local_delivery_free_cart_value?.value ?? "10 000"} zł `}
                              </span>
                              <br />
                            </>
                          )}
                          od{" "}
                          <span className="font-orange font-semibold">
                            {!postCode ? "?" :
                              isCode ? `${deliveryForProduct?.local?.price} zł` : `Niedostępne`}
                          </span>{" "}
                          - {deliveryForProduct?.local?.name}
                          <span onClick={openModalDeliveryCost}>(
                            {postCode && branch ? (
                              <span className="font-semibold font-blue" style={{ cursor: "pointer" }}>
                                Zmień
                              </span>
                            ) : (
                              <span className="font-semibold font-blue" style={{ cursor: "pointer" }}>
                                Oblicz
                              </span>
                            )})
                          </span>
                          <br />
                        </div>
                        {/* <div className="section">
                            <span className="font-orange font-semibold">0 zł</span>{" "}
                            dla zamówień powyżej{" "}
                            <span className="font-orange font-semibold">
                              {postCode === "17-200" ? `${deliveryConfig?.own_free_delivery_cart_value?.value ?? "1 500"}zł ` : `${deliveryConfig?.local_delivery_free_cart_value?.value ?? "10 000"} zł `}
                            </span>
                            *<br />
                            <Link
                              to={`${process.env.PUBLIC_URL}/info/mapa-zasiegu`}
                            >
                              *tylko na obszarze zasięgu
                            </Link>
                          </div> */}
                      </>
                    )}
                    <div className="section">
                      <span className="font-orange font-semibold" style={{ fontSize: "1.6rem" }}>
                        SPRZEDAŻ WYSYŁKOWA {deliveryForProduct?.custom?.length > 0 ? <span style={{ color: "#2e7d32" }}>✔</span> : "❌"}
                      </span>
                      <br />
                      {deliveryForProduct.custom && deliveryForProduct.custom.map((item, index) => (
                        <div key={index}>
                          <span className="font-orange font-semibold">
                            {item.price} zł
                          </span>{" "} - {item.name}
                          {item.min_shipping_value ? <span> powyżej {item.min_shipping_value}zł</span> : <span>(do {item.max_weight}kg)</span>}
                        </div>
                      ))}
                    </div>
                  </>
                  <div className="section" style={{ borderBottom: 'none' }}>
                    Masz pytania? Zadzwoń.
                    <br />
                    <span style={{ color: '#d87a30' }}>
                      tel.{" "}
                    </span>
                    <span style={{ color: '#d87a30' }}>
                      514 627 003
                    </span>
                  </div>
                  {deliveryTime && (
                    <div className="section">
                      Czas dostawy:{" "}
                      <span className="font-orange font-semibold">
                        {deliveryTime}
                      </span>
                    </div>
                  )}
                </>
              ) : null}
            </div>
            {/* <WidgetBanner src="assets/images/demo/banners/banner-sidebar.jpg" /> */}

            {/* <FeaturedProductsTwo /> */}
          </div>
          {/* <Modal
              isOpen={openBranch}
              onRequestClose={closeModal}
              shouldFocusAfterRender={false}
              className="shipping-popup"
              overlayClassName="cart-modal-overlay"
              closeTimeoutMS={10}
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">
                    <div className="col-lg-12">
                      <div className="modal-header mb-2">
                        <h3 className="modal-title">Wybierz oddział</h3>
                        <button type="button" className="close" onClick={closeModal} aria-label="Close">
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="product-single-filter">
                        <ul className="config-size-list">
                          {
                            branches.map(branch => (
                              <li className="col-lg-12" key={branch.branch_id}>
                                <button className="branches" style={{height: '4rem'}} name="branch_id" value={branch.branch_id} onClick={(e) => handleSubmitBranch(e, branch.branch_id, count)}>{branch.branch_name}</button>
                              </li>
                            ))
                          }
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal> */}
          <Modal
            isOpen={openDeliveryCost}
            onRequestClose={closeModal}
            shouldFocusAfterRender={false}
            className="shipping-popup"
            overlayClassName="cart-modal-overlay"
            closeTimeoutMS={10}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <form
                  onSubmit={handleSubmitDeliveryCost}
                  style={{ marginBottom: "0" }}
                >
                  <div className="modal-body">
                    <div className="col-lg-12">
                      <div className="modal-header mb-2">
                        <h3 className="modal-title">
                          Podanie kodu pocztowego pozwoli oszacować koszt
                          dostawy.
                        </h3>
                        <button
                          type="button"
                          className="close"
                          onClick={closeModal}
                          aria-label="Close"
                        >
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <InputMask
                        mask="99-999"
                        maskChar={null}
                        className="form-control"
                        name="address_post"
                        placeholder="Kod pocztowy"
                        onChange={handleChange}
                        value={form.address_post}
                        style={{ marginBottom: "0", marginTop: "1rem" }}
                      />
                      {errorPC.address_post && (
                        <span className="text-danger">
                          {errorPC.address_post}
                        </span>
                      )}
                      {/* <select className="form-control" id="branch" name="branch_id" onChange={handleChange} value={form.branch_id} style={{ marginBottom: '0', marginTop: '1rem' }}>
                          <option value="">Wybierz oddział</option>
                          {
                            branches.map(branch => (
                              <option key={branch.branch_id} value={branch.branch_id}>{branch.branch_name}</option>
                            ))
                          }
                        </select>
                        {errorBranch.branch_id && <span className="text-danger">{errorBranch.branch_id}</span>} */}
                    </div>
                    <div className="col-lg-12 mt-2">
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-link btn-sm"
                          onClick={closeModal}
                        >
                          Anuluj
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary btn-sm"
                        >
                          Oblicz
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Modal>
          <Modal
            isOpen={openPricing}
            onRequestClose={closeModal}
            shouldFocusAfterRender={false}
            className="login-popup"
            overlayClassName="cart-modal-overlay"
            closeTimeoutMS={10}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                {isSendCart ? (
                  <>
                    <div className="modal-body">
                      <button
                        type="button"
                        className="close"
                        onClick={closeModal}
                        aria-label="Zamknij"
                        style={{ position: "absolute", right: "0", top: "0" }}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                      <div className="col-lg-12 text-center mb-1">
                        <i
                          className="icon-check text-success"
                          style={{ fontSize: "100px" }}
                        ></i>
                        <br />
                        <span
                          className="h2 font-weight-normal"
                          style={{ lineHeight: "1.5" }}
                        >
                          Dziękujemy za złożenie zapytania.
                          <br />
                          Wycenę produktów otrzymasz maksymalnie w ciągu 48
                          godzin.
                          <br />
                          Nr. zapytania:{" "}
                          <span className="font-orange">
                            {order.data.order_nr_pricing}
                          </span>
                          <br />
                          <br />
                          Jeśli masz pytania, zadzwoń:
                          <br />
                          <span className="font-orange">+48 514 627 003</span>
                          <br />
                          <br />
                          Pamiętaj, że aby sfinalizować zakup wycenionych
                          produktów należy zaakceptować otrzymaną wycenę.
                          <br />
                        </span>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="btn btn-thirdy"
                      onClick={closeModal}
                    >
                      Zamknij
                    </button>
                  </>
                ) : (
                  <>
                    <form
                      onSubmit={handleSubmitPricing}
                      style={{ marginBottom: "0" }}
                    >
                      <div className="modal-body">
                        <div className="col-lg-12">
                          <div
                            className="modal-header"
                            style={{ padding: ".5rem 0" }}
                          >
                            <button
                              type="button"
                              className="close"
                              onClick={closeModal}
                              aria-label="Close"
                              style={{ fontSize: "3rem" }}
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                        </div>

                        <div className="col-lg-12 mb-2">
                          <div className="col-lg-12">
                            <div
                              className="row pt-3 pb-3 font-semibold"
                              style={{ borderBottom: "1px solid #ccc" }}
                            >
                              <div className="col-lg-9">Produkt</div>
                              <div className="col-lg-3 text-center">Ilość</div>
                            </div>
                            <div
                              className="row align-items-center pt-3 pb-3"
                              style={{ borderBottom: "1px solid #ccc" }}
                            >
                              <div className="col-lg-9">
                                <div className="row align-items-center">
                                  <div className="col-lg-3">
                                    {dataProduct.product
                                      ? dataProduct.product.images
                                        .slice(0, 1)
                                        .map((image) => (
                                          <figure
                                            className="product-image-container"
                                            key={image.product_image_id}
                                          >
                                            <img
                                              src={`https://d22u7e6casvzfe.cloudfront.net/uploads/products/150x150/${image.product_image}`}
                                              alt={!!image.product_image_alt ? image.product_image_alt : "product"}
                                            />
                                          </figure>
                                        ))
                                      : dataProduct.images
                                        .slice(0, 1)
                                        .map((image) => (
                                          <figure
                                            className="product-image-container"
                                            key={image.product_image_id}
                                          >
                                            <img
                                              src={`https://d22u7e6casvzfe.cloudfront.net/uploads/products/150x150/${image.product_image}`}
                                              alt={!!image.product_image_alt ? image.product_image_alt : "product"}
                                            />
                                          </figure>
                                        ))}
                                  </div>
                                  <div className="col-lg-9">
                                    {dataProduct.product
                                      ? dataProduct.product_variant_name
                                      : dataProduct.product_name}
                                    {dataProduct.product_variant_attr1 ||
                                      dataProduct.product_variant_attr2 ||
                                      dataProduct.product_variant_attr3 ? (
                                      <div
                                        className="pt-2"
                                        style={{ fontSize: "12px" }}
                                      >
                                        {dataProduct.product_variant_attr1
                                          ? (dataProduct.product.attribute1
                                            .attribute_value || dataProduct.product.attribute1
                                              .attribute_name) +
                                          ": " + attribute1Value : null}
                                        {dataProduct.product_variant_attr2 ? (
                                          <>
                                            <br />
                                            {(dataProduct.product.attribute2
                                              .attribute_value || dataProduct.product.attribute2
                                                .attribute_name) +
                                              ": " +
                                              attribute2Value || ''}
                                          </>
                                        ) : null}
                                        {dataProduct.product_variant_attr3 ? (
                                          <>
                                            <br />
                                            {(dataProduct.product.attribute3
                                              .attribute_value || dataProduct.product.attribute3
                                                .attribute_name) +
                                              ": " +
                                              attribute3Value || ''}
                                          </>
                                        ) : null}
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-3 text-center">
                                {(dataProduct.product &&
                                  dataProduct.product.full_package) ||
                                  dataProduct.full_package ? (
                                  <div
                                    className="product-single-qty mb-0"
                                    style={{
                                      maxHeight: "unset",
                                      display: "flex",
                                    }}
                                  >
                                    <div className="w-50 float-left pr-0 bootstrap-touchspin bootstrap-touchspin-injected">
                                      <input
                                        className="horizontal-quantity form-control package-type-left mw-100"
                                        type="number"
                                        min={
                                          (dataProduct.package &&
                                            dataProduct.package.package_value_type ===
                                            "metric") ||
                                            (dataProduct.product &&
                                              dataProduct.product.package
                                                .package_value_type === "metric")
                                            ? "0.01"
                                            : "1"
                                        }
                                        value={productPricingQty}
                                        step={
                                          (dataProduct.package &&
                                            dataProduct.package
                                              .package_value_type ===
                                            "metric") ||
                                            (dataProduct.product &&
                                              dataProduct.product.package
                                                .package_value_type === "metric")
                                            ? "0.01"
                                            : "1"
                                        }
                                        onChange={(e) => setQty(e)}
                                        onFocus={(e) => e.target.select()}
                                      />
                                      <span className="package-unit">
                                        {dataProduct.product
                                          ? dataProduct.product.package
                                            .package_value
                                          : dataProduct.package.package_value}
                                      </span>
                                    </div>
                                    <div className="w-50 float-left pl-0 bootstrap-touchspin bootstrap-touchspin-injected">
                                      <input
                                        className="horizontal-quantity form-control package-type-right mw-100"
                                        type="number"
                                        min="1"
                                        value={fullPackage}
                                        onChange={handleChangeFullPackage}
                                        onFocus={(e) => e.target.select()}
                                      />
                                      <span className="package-unit">
                                        {dataProduct.product
                                          ? dataProduct.product.full_package
                                            .package_value
                                          : dataProduct.full_package
                                            .package_value}
                                      </span>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="product-single-qty">
                                    <div className="input-group bootstrap-touchspin bootstrap-touchspin-injected">
                                      <span className="input-group-btn input-group-prepend">
                                        <button
                                          className="btn btn-outline btn-down-icon bootstrap-touchspin-down"
                                          onClick={countDown}
                                          type="button"
                                        ></button>
                                      </span>
                                      <input
                                        className="horizontal-quantity form-control"
                                        type="number"
                                        min={
                                          (dataProduct.package &&
                                            dataProduct.package.package_value_type ===
                                            "metric") ||
                                            (dataProduct.product &&
                                              dataProduct.product.package
                                                .package_value_type === "metric")
                                            ? "0.01"
                                            : "1"
                                        }
                                        value={productPricingQty}
                                        onChange={(e) => setQty(e)}
                                        step={
                                          (dataProduct.package &&
                                            dataProduct.package
                                              .package_value_type ===
                                            "metric") ||
                                            (dataProduct.product &&
                                              dataProduct.product.package
                                                .package_value_type === "metric")
                                            ? "0.01"
                                            : "1"
                                        }
                                        onFocus={(e) => e.target.select()}
                                      />
                                      <span className="input-group-btn input-group-append">
                                        <button
                                          className="btn btn-outline btn-up-icon bootstrap-touchspin-up"
                                          onClick={countUp}
                                          type="button"
                                        ></button>
                                      </span>
                                    </div>
                                  </div>
                                )}
                                <span className="negotiations-qty">
                                  {dataProduct.product
                                    ? dataProduct.product.package.package_value
                                    : dataProduct.package.package_value}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12 mb-2">
                          <h2 className="step-title mt-0 mb-1">
                            Dane kontaktowe
                          </h2>
                          {!user ? (
                            <p>
                              Masz już u nas konto?{" "}
                              <Link
                                to={`${process.env.PUBLIC_URL}/logowanie`}
                                state={{
                                  from: location.pathname,
                                  productPricingQty,
                                }}
                                className="font-orange font-semibold"
                              >
                                Zaloguj się
                              </Link>{" "}
                              lub kontynuuj jako gość.
                            </p>
                          ) : null}
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="form-group required-field">
                                <label>Imię </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="name"
                                  value={form.name}
                                  onChange={handleChange}
                                />
                                {errorUserData.name && (
                                  <span className="text-danger">
                                    {errorUserData.name}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-group required-field">
                                <label>Kod pocztowy dostawy </label>
                                <InputMask
                                  mask="99-999"
                                  maskChar={null}
                                  className="form-control"
                                  name="address_post"
                                  value={form.address_post}
                                  onChange={handleChange}
                                />
                                {errorPC.address_post && (
                                  <span className="text-danger">
                                    {errorPC.address_post}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-6">
                              {/* <div className={`form-group ${!noPLnumber ? 'required-field' : ''}`}> */}
                              <div className="form-group required-field">
                                <label>Telefon </label>
                                {/* <InputMask mask="999 999 999" maskChar={null} type="tel" className="form-control" name="phone" disabled={noPLnumber} */}
                                <InputMask
                                  mask="99999999999"
                                  maskChar={null}
                                  type="tel"
                                  className="form-control"
                                  name="phone"
                                  value={form.phone}
                                  onChange={handleChange}
                                />
                                {errorUserData.phone && (
                                  <span className="text-danger">
                                    {errorUserData.phone}
                                  </span>
                                )}
                                {checkPhone ? (
                                  <div className="text-danger">
                                    Podany numer telefonu istnieje już w
                                    serwisie.
                                  </div>
                                ) : null}
                              </div>

                              {/* <div className="custom-control custom-checkbox mt-1 m-0">
                                  <input type="checkbox" className="custom-control-input" id="plnumber"
                                    checked={noPLnumber}
                                    onChange={(e) => handleChangeNoPLnumber(e)}
                                  />
                                  <label className="custom-control-label" htmlFor="plnumber" style={{cursor: 'pointer'}}>Nie mam polskiego numeru</label>
                                </div> */}
                            </div>
                            <div className="col-lg-6">
                              <div className="form-group required-field">
                                <label>Adres e-mail </label>
                                <input
                                  type="email"
                                  className="form-control"
                                  name="email"
                                  value={form.email}
                                  onChange={handleChange}
                                />
                                {errorUserData.email && (
                                  <div className="text-danger">
                                    {errorUserData.email}
                                  </div>
                                )}
                                {checkEmail ? (
                                  <span className="text-danger">
                                    Podany adres e-mail istnieje już w serwisie.
                                  </span>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <textarea
                            className="form-control form-control-sm mw-100"
                            name="comment"
                            placeholder="Komentarz"
                            style={{ border: "1px solid #d3d3d3" }}
                            value={form.comment}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="mt-2" style={{ padding: "0 1rem" }}>
                        <div className="col-lg-12">
                          <div className="modal-footer d-block">
                            <div className="row align-items-center">
                              <div className="col-lg-6">
                                {!user ? (
                                  <>
                                    <div className="custom-control custom-checkbox m-0">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="regulations"
                                        name="regulations"
                                        checked={form.regulations}
                                        onChange={handleChangeCheckbox}
                                      />
                                      <label
                                        className="custom-control-label"
                                        htmlFor="regulations"
                                        style={{ cursor: "pointer" }}
                                      >
                                        Akceptuję regulamin -{" "}
                                        <Link
                                          to={`${process.env.PUBLIC_URL}/regulamin`}
                                          className="link"
                                        >
                                          zobacz
                                        </Link>
                                      </label>
                                    </div>
                                    {errorRegulations.regulations && (
                                      <span className="text-danger">
                                        {errorRegulations.regulations}
                                      </span>
                                    )}
                                  </>
                                ) : null}
                              </div>
                              <div className="col-lg-6 text-right">
                                <button
                                  type="button"
                                  className="btn btn-link btn-sm"
                                  onClick={closeModal}
                                >
                                  Zamknij
                                </button>
                                <button
                                  type="submit"
                                  className="btn btn-primary btn-sm"
                                  disabled={disabledBtn}
                                >
                                  Prześlij do wyceny
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    {sendOrder ? (
                      <div
                        className="loading-overlay"
                        style={{ background: "rgba(0,0,0,.7)" }}
                      >
                        <div className="bounce-loader">
                          <div className="bounce1"></div>
                          <div className="bounce2"></div>
                          <div className="bounce3"></div>
                        </div>
                      </div>
                    ) : null}
                  </>
                )}
              </div>
            </div>
          </Modal>
          {/* <Modal
              isOpen={openHistoryPrice}
              onRequestClose={closeModal}
              shouldFocusAfterRender={false}
              className="login-popup"
              overlayClassName="cart-modal-overlay"
              closeTimeoutMS={10}
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">
                    <div className="col-lg-12">
                      <div className="modal-header">
                        <h3 className="modal-title">Historia ceny</h3>
                        <button type="button" className="close" onClick={closeModal} aria-label="Close" style={{fontSize:'3rem'}}>
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>

                      <div className="col-lg-12 pt-3 pb-3">
                        <div className="row">
                          <div className="col-lg-6">Data</div>
                          <div className="col-lg-6">Cena</div>
                        </div>
                      </div>

                      <table className="table table-striped mb-0">
                        <thead>
                          <tr>
                            <th></th>
                            <th>Data</th>
                            <th>Cena</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            productPriceHistory.map((p, i) => (
                              <tr key={p.history_price_id}>
                                <th>{i + 1}</th>
                                <td>{new Date(p.created_at).toLocaleDateString()}</td>
                                <td>{p.price} zł</td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>

                      <div className="modal-footer d-block">
                        <div className="row align-items-center">
                          <div className="col-lg-12 text-right">
                            <button type="button" className="btn btn-link btn-sm" onClick={closeModal}>Zamknij</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal> */}
        </StickyBox>
      ) : null}
      <div className="skel-pro skel-detail"></div>
    </aside>
  );
};

const mapStateToProps = (state) => {
  return {
    wishlist: state.users.wishlist,
    branches: state.branches.branches ? state.branches.branches : [],
    productDeliveryCost: state.products.productDeliveryCost
      ? state.products.productDeliveryCost
      : null,
    deliveryConfig: state.products.deliveryConfig
  };
};

export default connect(mapStateToProps, {
  quickAddToCart,
  addToPricing,
  addFavoriteProduct,
  deleteFavoriteProduct,
})(ProductSidebarOne);
